import { useEffect, useState } from "react";

interface Props {
  seconds: number;
  onDone?: () => void;
}

export function Countdown({ seconds, onDone }: Props) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (remaining <= 0) {
      onDone?.();
      return;
    }
    const t = window.setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => window.clearTimeout(t);
  }, [remaining, onDone]);

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-cap-deep/80 backdrop-blur-sm">
      <div className="text-center">
        <div className="font-display text-2xl uppercase tracking-[0.4em] text-white/60">
          Match Starts In
        </div>
        <div className="mt-4 font-display text-[12rem] leading-none text-cap-gold drop-shadow-[0_0_30px_rgba(240,179,35,0.5)]">
          {remaining > 0 ? remaining : "GO!"}
        </div>
      </div>
    </div>
  );
}
